import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addSupplierApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const addSupplier = createAsyncThunk('addSupplier', async (payload) => {
  return await addSupplierApi(payload);
});

const addSupplierSlice = createSlice({
  name: 'addSupplier', // Unique Name
  initialState,
  reducers: {
    addSupplierReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addSupplier.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(addSupplier.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(addSupplier.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { addSupplierReset } = addSupplierSlice.actions;

export default addSupplierSlice.reducer;
